<template>
<div id="apptable" v-cloak>

    <b-card header="News" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <label for="datainizio">Data inizio:</label>
                    <b-form-input v-model="datainizio" id="datainizio" type="date" />
                </div>
                <div class="col-md-3">
                    <label for="datafine">Data fine:</label>
                    <b-form-input v-model="datafine" id="datafine" type="date" />
                </div>
            </div>

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="nominativo" scope="row">{{row.value}}</template>
                <template slot="visibilitaVis" scope="row">{{row.value}}</template>
                <template slot="datainizio" scope="row">{{row.value | formatDate}}</template>
                <template slot="datafine" scope="row">{{row.value | formatDate}}</template>
                <!-- <template slot="flagnotificaVis" scope="row">{{row.value}}</template> -->
                <template slot="attivoVis" scope="row">{{row.value}}</template>
                <!-- <template slot="giorniprima" scope="row">{{row.value}}</template> -->
                <template slot="voto" scope="row"><star-rating v-show="(row.value > 0)" v-model="row.value" read-only :increment="0.01" :star-size="25" :show-rating="false"></star-rating></template>


                <template slot="modifica" scope="row">
                    <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                    <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                </template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della news #{{deleteModal.id}}: {{deleteModal.titolo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {
            deleteModal: {
                id: null,
                titolo: '',
                show: false
            },
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                nominativo: {
                    label: 'Titolo',
                    sortable: true
                },
                visibilitaVis: {
                    label: 'Visibilità',
                    sortable: true
                },
                datainizio: {
                    label: 'Data inizio',
                    sortable: true
                },
                datafine: {
                    label: 'Data fine',
                    sortable: true
                },                
/*                 flagnotificaVis: {
                    label: 'Flag notifica',
                    sortable: true
                }, */
                attivoVis: {
                    label: 'Attiva',
                    sortable: true
                },
/*                 giorniprima: {
                    label: 'Giorni prima',
                    sortable: true
                }, */
                voto: {
                    label: 'Voto medio',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 5,
            pageOptions: [{
                text: 5,
                value: 5
            }, {
                text: 10,
                value: 10
            }, {
                text: 15,
                value: 15
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false,
            datainizio: this.$route.params.datainizio || null,
            datafine: this.$route.params.datafine || null
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    watch: {
        filter: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine)  
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/news/filter/${this.filter}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/news/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }

        },
        datainizio: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine)        
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/news/filter/${this.filter}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/news/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }          
            this.refreshData();            
        },
        datafine: function (newValue, oldValue) {  
            this.datainizio = (this.datainizio == '' ? null : this.datainizio)  
            this.datafine = (this.datafine == '' ? null : this.datafine)  
            if((this.filter || '') !== ''){
                this.$router.replace({
                    path: `/app/news/filter/${this.filter}/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }
            else{
                this.$router.replace({
                    path: `/app/news/datainizio/${this.datainizio}/datafine/${this.datafine}`
                });
            }         
            this.refreshData(); 
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    methods: {
        insert() {
            this.$router.push('/app/dettaglionews');
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettaglionews/${item.id}`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getTipo(tipo) {
            var vis = new Visibilità();
            return vis.getTipoByFlag(tipo);
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.titolo = item.descrizione;
            this.deleteModal.show = true;
        },
        delItem() {

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/news/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < this.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                        this.deleteModal.show = false;
                        this.showerror = true;
                        this.error = "Errore: " + e.message;
                    }
                })
                .catch(e => {
                    this.deleteModal.show = false;
                    this.showerror = true;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        refreshData() {

            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + `rest/news/datainizio/${this.datainizio}/datafine/${this.datafine}`, {        
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function (element, index) {
  
                            //per la ricerca
                            element.datainizio_ric = apptable.$options.filters.formatDate(element.datainizio);
                            element.datafine_ric = apptable.$options.filters.formatDate(element.datafine);

                            element.visibilitaVis = apptable.getTipo(element.tipo);
                            element.flagnotificaVis = (element.flagnotifica == 'S' ? 'Sì' : 'No');
                            element.attivoVis = (element.flagsta == 'S' ? 'Sì' : 'No'); 

                            var visibilità = new Visibilità();
                            element.visibilitaVis = visibilità.getTipoByFlag(element.visibilita);

                            delete element.uteins; //per motivi di ricerca

                        });

                        apptable.items = apptable.items.filter(function (element) {                       
                            return ctrlViscategoria(element.id_categoria);
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

        }
    },
    created: function () {
        


        if(!ctrlVismenu("N")){
            this.$router.replace('/accessdenied');
            return;
        }

        this.refreshData();        

    }
}
</script>
